/*******************************************************************************
 * Copyright     : Copyright (c)  2021 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : App.tsx
 *
 * Project Title : APM Settings Tool
 *
 * Description   : Root App component
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : Dec 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            : <Author>
 * On            : <Date>
 * Description   : <Description>
 *******************************************************************************/
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "components/Auth";
import { PageRoutes } from "./PageRoutes";
import React, { FC } from "react";

export const App: FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <PageRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
